// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"cec70d38","518":"75b9f255","534":"a466509b"}[chunkId] + ".chunk.css";
};